import { Components, Theme } from '@mui/material';

export const alertStyles: Components<Theme>['MuiAlert'] = {
  styleOverrides: {
    root: ({ theme, ownerState }) => {
      switch (ownerState.severity) {
        case 'error':
          return {
            padding: '16px',
            backgroundColor: theme.palette.error.light,
            border: 'none'
          };
        case 'info':
          return {
            padding: '16px',
            backgroundColor: 'white',
            border: `1px solid ${theme.palette.primary.main}`
          };
        case 'success':
          return {
            padding: '16px',
            backgroundColor: theme.palette.successV2.light,
            border: 'none'
          };
        case 'warning':
          return {
            padding: '16px',
            backgroundColor: theme.palette.warningV2.light,
            border: 'none'
          };
      }
    },
    message: ({ theme, ownerState }) => {
      const color =
        ownerState.severity === 'error'
          ? theme.palette.error.main
          : ownerState.severity === 'info'
          ? theme.palette.customGrey.dark
          : ownerState.severity === 'success'
          ? theme.palette.successV2.main
          : ownerState.severity === 'warning'
          ? theme.palette.warningV2.dark
          : undefined;

      return {
        color,
        fontWeight: 'bold',
        fontSize: '16px'
      };
    },
    icon: ({ theme, ownerState }) => {
      const color =
        ownerState.severity === 'error'
          ? theme.palette.error.main
          : ownerState.severity === 'info'
          ? theme.palette.primary.main
          : ownerState.severity === 'success'
          ? theme.palette.successV2.main
          : ownerState.severity === 'warning'
          ? theme.palette.warningV2.main
          : undefined;
      return {
        color
      };
    }
  }
};
